"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Playlist = void 0;
var program_1 = require("./program/program");
var constants_1 = require("../constants");
var episode_1 = require("./program/episode");
var clip_1 = require("./program/clip");
var movie_1 = require("./program/movie");
var Playlist = (function () {
    function Playlist(data) {
        var _this = this;
        var _a;
        this.items = [];
        this.applyModel = function (item) {
            switch (item.type) {
                case constants_1.PROGRAM_TYPE.EPISODE:
                    return new episode_1.Episode(item);
                case constants_1.PROGRAM_TYPE.CLIP:
                    return new clip_1.Clip(item);
                case constants_1.PROGRAM_TYPE.MOVIE:
                    return new movie_1.Movie(item);
                default:
                    return new program_1.Program(item);
            }
        };
        if (!((_a = data === null || data === void 0 ? void 0 : data.programs) === null || _a === void 0 ? void 0 : _a.items)) {
            return;
        }
        this.items = data.programs.items.map(function (item) { return _this.applyModel(item); });
    }
    return Playlist;
}());
exports.Playlist = Playlist;
